







































































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { fetchMID } from './fetchMID';
import FiltrosBusqueda from '@/pantallas/Conecta/Clientes/FiltrosBusqueda.vue';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { AgGridVue } from 'ag-grid-vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import ConsultaInstalacionesBase from '../Conecta/ConsultaInstalaciones/ConsultaInstalacionesBase.vue';

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    FiltrosBusqueda,
  },
})
export default class AsignacionvehiculosWS extends ComponenteBase {
  [x: string]: any;
  filtro: any = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades = Funcionalidades.EstadoPatente;
  clienteId: number = config.getClienteSesion();
  showTables = false;
  clientesAll: any = [];
  extractedData: any[] = [];
  filtro2: any = '';

  tablaDatos: any = [];
  visible: boolean = false;
  pagination: any = {
    rowsPerPage: 5,
  };
  rowsPerPage: any = [5, 10, 25, { text: 'Todos', value: -1 }];

  formFields: {
    clientes: any;
  } = {
    clientes: {
      label: 'Clientes',
      value: '',
      items: this.clientesall,
      formatItem: (item: { nombre: any; rut: any }) =>
        `${item.nombre} [${item.rut}]`,
    },
  };

  async getEndpoint() {
    let self = this;
    this.loadingService.showLoading();
    this.tablaDatos = [];
    this.ordesList = [];
    return fetchMID(
      {
        clienteid: this.formFields.clientes.value.toString(),
        patente: this.filtro.toUpperCase(),
      },
      'mid_cliente/GetEstadoEnvioPatente'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          data.data.data.forEach((e: any) => {
            const plataforma = e.vehiculo[0].plataforma;
            const flota = e.vehiculo[0].flota;
            const grupo = e.vehiculo[0].grupo_vehiculo;
            const nombre = e.vehiculo[0].patente;
            const patente = e.vehiculo[0].patente;
            const nombre_ws = e.integracion.nombrewebservice;
            const integrador = e.integracion.integrador;
            const ultimoEventoGPS = e.vehiculo[0].ultimo_evento_gps;
            const ultimoEnvioWS = e.vehiculo[0].fecha_ultimo_envio;
            const ultimoEnvioerror = e.vehiculo[0].fecha_ultimo_error;
            const respuestaIntegrador = e.vehiculo[0].respuesta_integrador;
            const dataLogEnvio = e.vehiculo[0].data_log_envio;
            this.tablaDatos.push({
              plataforma,
              flota,
              grupo,
              nombre,
              patente,
              nombre_ws,
              integrador,
              ultimoEventoGPS,
              ultimoEnvioWS,
              respuestaIntegrador,
              dataLogEnvio,
              ultimoEnvioerror,
            });
          });
          this.visible = true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.error('Error:', error);
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  filtroUpperCase() {
    this.filtro = this.filtro.toUpperCase();
  }
  filtro2UpperCase() {
    this.filtro2 = this.filtro2.toUpperCase();
  }
  async getAllCliente() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID({ canal: 'gpschile' }, 'marcaBlanca/getClient')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.cliente = data.data.data || [];
          const filteredDatas = this.cliente
            .map((item: { nombre: any; rut: any; id: any }) => ({
              nombre: item.nombre,
              rut: item.rut,
              id: item.id,
            }))
            .sort((a: any, b: any) => {
              if (a.nombre > b.nombre) {
                return 1;
              } else if (a.nombre < b.nombre) {
                return -1;
              } else {
                return 0;
              }
            });

          if (filteredDatas.length > 0) {
            this.clientesAll = filteredDatas;
          }

          const clienteMid = sessionStorage.getItem('clienteMid');

          // Si hay un valor, busque el ID correspondiente en la lista de clientes
          if (clienteMid) {
            const clienteId = parseInt(clienteMid, 10);
            const clienteEncontrado = this.clientesAll.find(
              (cliente: { id: number }) => cliente.id === clienteId
            );

            if (clienteEncontrado) {
              // Seleccione el cliente encontrado
              this.formFields.clientes.value = clienteEncontrado.id;
            }
          }
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async handleGridReady() {
    if (
      this.formFields.clientes.value == '' ||
      this.formFields.clientes.value === null ||
      this.formFields.clientes.value === undefined
    ) {
      this.$snotify.error('Selecione un cliente', { timeout: 3000 });
    } else {
      if (this.filtro == '') {
        this.$snotify.error('Ingrese una Patente Valida', { timeout: 3000 });
        this.visible = false;
      } else {
        sessionStorage.setItem('clienteMid', this.formFields.clientes.value);
        this.tablaDatos = [];
        this.ordesList = [];
        await this.getEndpoint();
        const transformedData = this.tablaDatos;
        this.gridApi.setRowData(transformedData);
        this.gridApi.setDomLayout('autoHeight');
      }
    }
  }
  filtroForm() {
    // Aplica el filtro y crea un nuevo array con los elementos filtrados
    const filteredData = this.tablaDatos.filter(
      (item: { [s: string]: unknown } | ArrayLike<unknown>) => {
        return Object.values(item).some(value => {
          // Verifica si algún valor del objeto contiene el término de búsqueda
          return String(value).includes(this.filtro2);
        });
      }
    );
    const transformedData = filteredData;
    this.gridApi.setRowData(transformedData);
    this.gridApi.setDomLayout('autoHeight');
  }

  clearForm() {
    this.filtro2 = null;
    this.handleGridReady();
  }
  async clearFilters() {
    this.formFields.clientes.value = undefined;
    this.visible = false;
    this.filtro = undefined;
  }
  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar];

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  usuarioId: number = store.state.userId;

  mounted() {
    this.getAllCliente();
  }

  beforeDestroy() {}

  gridApi: GridApi = null;
  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Flota',
        field: 'flota',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Grupo',
        field: 'grupo',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Patente',
        field: 'patente',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Nombre de Endpoint',
        field: 'nombre_ws',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
        cellStyle: { whiteSpace: 'pre-wrap' },
      },
      {
        headerName: 'Integrador',
        field: 'integrador',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Fecha Último Evento Gps',
        field: 'ultimoEventoGPS',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Fecha Último Envío de Endpoint',
        field: 'ultimoEnvioWS',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Fecha Último Error Registrado',
        field: 'ultimoEnvioerror',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Fecha Actividad Enviada',
        field: 'host_maquina',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        filter: true,
      },
      {
        headerName: 'Respuesta Integrador',
        field: 'respuestaIntegrador',
        sortable: true,
        resizable: true,
        lockPinned: true,
        filter: true,
        autoHeight: true,
        width: 300,
        minWidth: 300,
        cellStyle: { whiteSpace: 'pre-wrap', lineHeight: '15px' },
      },
      {
        headerName: 'Log Último Envío',
        field: 'dataLogEnvio',
        sortable: true,
        resizable: true,
        lockPinned: true,
        filter: true,
        autoHeight: true,
        width: 300,
        minWidth: 300,
        cellStyle: { whiteSpace: 'pre-wrap', lineHeight: '15px' },
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      cacheBlockSize: 6, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: true,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.onGridReady,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
    };
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.handleGridReady();
  }
}
